import { ChangeEvent } from "react";
import moment from "moment";

import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { LinkingPopupService } from "@/Common/Components/Modals/LinkingPopup/LinkingPopupService";
import { EmployeeTitleHelper } from "@/Common/Helpers/EmployeeTitleHelper";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { PendingApprovalStatus } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { PendingApprovalNoteModel } from "@/Patient/Api/Dto/Responses/PendingApprovalNoteModel";
import { IPendingApprovalInboxModel } from "@/Portfolio/Models/UI/IPendingApprovalInboxModel";

interface IResidentApprovalPortfolioPopup {
    onCloseCallback: () => void;
    Model: IPendingApprovalInboxModel;
}

class ResidentApprovalPortfolioPopup extends React.Component<IResidentApprovalPortfolioPopup, never> {
    private id = "residentapprovalportfoliopopup";

    public render(): JSX.Element {
        var notesRender = null;
        var noteList = this.props.Model.get("PendingNoteNotesList").toArray();
        if (noteList && noteList.length > 0) {
            notesRender = noteList.map((note: PendingApprovalNoteModel, idx: number) => (
                <div key={"_n" + idx}>
                    <div>
                        <strong>
                            {cacheStore.GetCliniciansPersonsByContactId(note.EmployeeContactId).NameWithPrefix}
                        </strong>
                        <span style={{ color: "#777", fontSize: ".92em", marginLeft: "5px" }}>
                            {moment(note.CreationDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("LowerCaseAtLabel") + " " + moment(note.CreationDate).format("hh:mm:ss")}
                        </span>
                    </div>
                    <div>
                        <span>{JSXHelper.BreakStringIntoParagraphs(note.Note)}</span>
                    </div>
                </div>
            ));
        }

        return (
            <div id={this.id} onClick={this.stopPropagation.bind(this)} className="pending-approval-popup" style={{ left: "40%" }} data-cy={this.id}>
                <div className="pa-header">
                    <div className="flex-container">
                        <h4>{cacheStore.GetString("SupervisionNoteLabel")}</h4>
                        <div className="text-right">
                            <a className="close" onClick={() => this.props.onCloseCallback()} aria-label="Close">×</a>
                        </div>
                    </div>
                </div>
                <div className="pa-main">
                    {EmployeeTitleHelper.isStudent(sessionStore.myleEmployeeTitle) && (
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-2 text-right">
                                <label className="label-input">{cacheStore.GetString("SupervisorLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-10 col-sm-10">
                                {this.props.Model.get("ApprovalSupervisorSelectedClinicians").count() > 0 && (
                                    <div>
                                        <label className="label-input">{this.props.Model.get("ApprovalSupervisorClinicianName")}</label> <span style={{ marginLeft: "5px" }} onClick={this.RemoveSelectedClinician.bind(this)} className="glyphicon glyphicon-remove red-text pointer push-right" />
                                    </div>
                                )}
                                {this.props.Model.get("ApprovalSupervisorSelectedClinicians").count() === 0 && (
                                    <div>
                                        <TextboxControl
                                            autoCompleteItems={Immutable.List(this.props.Model.get("ApprovalSupervisorClinicians").map(x => new SearchableItemModelT<Person>(x.NameWithPrefix, x.ContactId, x)).toList())}
                                            onAutoCompleteSelectCallBackOperation={LocalOperations.Portfolio.PendingApproval_SelectResidentSupervisor}
                                            onAutoCompleteSelectClearTextBox={true}
                                            value={this.props.Model.get("ApprovalSupervisorClinicianName")}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    <div className="note-pa-render">
                        {notesRender}
                    </div>
                    {this.props.Model.get("SelectedPendingApprovalStatus") != PendingApprovalStatus.Approved && (
                        <div>
                            <label>{cacheStore.GetString("MessageLabel")}</label>
                            <textarea className="form-control" id="rap_note" value={this.props.Model.get("ApprovalResidentMessage")} onChange={this.onMessageChange.bind(this)} rows={4} />
                        </div>
                    )}
                </div>
                <div className="pa-footer">
                    {EmployeeTitleHelper.isStudent(sessionStore.myleEmployeeTitle)
                        && this.props.Model.get("SelectedPendingApprovalStatus") != PendingApprovalStatus.Approved
                        && (
                            <div className="text-right">
                                <button className="btn btn-default push-right-5" onClick={() => this.props.onCloseCallback()}>{cacheStore.GetString("CancelLabel")}</button>
                                <button className="btn btn-primary push-right-5" disabled={this.props.Model.get("ApprovalSupervisorSelectedClinicians").count() === 0} onClick={this.onSendClick.bind(this)}>{cacheStore.GetString("SendLabel")}</button>
                                <button className="btn btn-primary" disabled={this.props.Model.get("ApprovalSupervisorSelectedClinicians").count() === 0} onClick={this.onModifyClick.bind(this)}>{cacheStore.GetString("ModifyLabel")}</button>
                            </div>
                        )
                    }
                    {sessionStore.getCurrentEmployee().ContactId === this.props.Model.get("SelectedPendingApprovalSupervisorContactId")
                        && this.props.Model.get("SelectedPendingApprovalStatus") != PendingApprovalStatus.Approved
                        && (
                            <div className="text-right">
                                <button className="btn btn-default push-right-5" onClick={() => this.props.onCloseCallback()}>{cacheStore.GetString("CancelLabel")}</button>
                                <button className="btn btn-primary push-right-5" onClick={this.onReturnClick.bind(this)}>{cacheStore.GetString("ReturnLabel")}</button>
                                <button className="btn btn-primary" onClick={this.onApproveClick.bind(this)}>{cacheStore.GetString("ApproveLabel")}</button>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        const elem = $("#" + this.id);
        const cnt = document.body;
        const dragOptions = {
            containment: cnt,
            handle: ".pa-header"
        };
        elem.draggable(dragOptions);
    }
    public componentWillUnmount(): void {
        overlayStore.hideAllOverlays();
        const elem = $("#" + this.id);
        elem.draggable("destroy");
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private RemoveSelectedClinician(): void {
        LocalEvent.Dispatch(LocalOperations.Portfolio.PendingApproval_ClearSelectedSupervisor);
    }

    private onMessageChange(e: ChangeEvent<HTMLTextAreaElement>): void {
        var operation = new LocalEvent(LocalOperations.Portfolio.PendingApproval_OnResidentMessageChange);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    private onSendClick(): void {
        LocalEvent.Dispatch(LocalOperations.Portfolio.PendingApproval_OnSendClick);
    }

    private onModifyClick(): void {
        LocalEvent.Dispatch(LocalOperations.Portfolio.PendingApproval_OnModifyEncounterClick);
    }

    private onReturnClick(): void {
        LocalEvent.Dispatch(LocalOperations.Portfolio.PendingApproval_OnReturnPopupClick);
    }

    private onApproveClick(): void {
        const tableData = this.props.Model.get("TableData");
        const encounterId = this.props.Model.get("SelectedPendingApprovalEncounterId");
        const selectedEncounter = tableData.filter(x => x.Model.EncounterId === encounterId).toArray().firstOrDefault();

        LinkingPopupService
            .promptForAdditionalSignOffInformation(
                this.props.Model.get("SelectedPendingApprovalPatientContactId"),
                selectedEncounter.Model.SiteId,
                selectedEncounter.Model.AppointmentId,
                null
            )
            .then(info => {
                sessionStore.dispatch(
                    LocalOperations.Portfolio.PendingApproval_OnApprovePopupClick,
                    {
                        additionalSignOffInformation: info
                    }
                );
            })
            .catch(p => p && console.error(p)); // prompt cancelled
    }
}

export { ResidentApprovalPortfolioPopup };
